/* eslint-disable max-len */
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

const postSlider = {
  settings: {
    arrows: false,
    pagination: false,
  },
  init() {
    this.initSwiper();
  },
  initSwiper: () => {
    postSlider.settings.arrows = {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    };
    postSlider.settings.pagination = {
      clickable: 'true',
      el: '.swiper-pagination',
    };
    const swiperItems = document.querySelectorAll('.post-swiper');
    if (!swiperItems.length) {
      return;
    }

    swiperItems.forEach((item) => {
      /* eslint-disable no-unused-vars */
      const swiper = new Swiper(item, {
        modules: [Navigation, Pagination, Autoplay],
        simulateTouch: true,
        loop: false,
        speed: 400,
        spaceBetween: 40,
        slidesPerView: item.dataset.spp,
        navigation: item.dataset.showArrows ? postSlider.settings.arrows : false,
        pagination: item.dataset.showPagination ? postSlider.settings.pagination : false,
        autoplay: {
          delay: 2000,
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
          // when window width is >= 640px
          1024: {
            spaceBetween: 40,
            slidesPerView: item.dataset.spp,
          },
        },
      });
    });
  },

};

export default postSlider;
postSlider.init();
